// extracted by mini-css-extract-plugin
export default {"container":"fdiTable_container__sgUNv","header":"fdiTable_header__4F7Eg"};